import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { IngredientCreateInfoPage } from "../../ingredient-create/ingredient-create-info/ingredient-create-info";
import { IngredientCompCreateInfoPage } from "../../ingredient-comp-create/ingredient-comp-create-info/ingredient-comp-create-info";
import { ProviderOrderAddPage } from '../../../providers/orders/provider-order-add/provider-order-add';
import { Globals } from '../../../../globals';

/**
 * Generated class for the IngredientViewNamePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-view-name',
    templateUrl: 'ingredient-view-name.html',
})
export class IngredientViewNamePage {
    @Input() ingredient: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {
    }

    edit() {

        if (this.ingredient.sub_recipe == false) {
            this.navCtrl.push(IngredientCreateInfoPage, {
                update_state: true,
                ingredient_uid: this.ingredient.UID,
                ingredient_name: this.ingredient.name,
                measurement: this.ingredient.measurement,
                stock: this.ingredient.stock,
                stock_alert: this.ingredient.stock_alert,
                stock_max: this.ingredient.stock_max,
                tags: this.ingredient.tags
            })
        } else {
            this.navCtrl.push(IngredientCompCreateInfoPage, {
                update_state: true,
                ingredient_uid: this.ingredient.UID,
                ingredient_name: this.ingredient.name,
                measurement: this.ingredient.measurement,
                stock: this.ingredient.stock,
                stock_alert: this.ingredient.stock_alert,
                stock_max: this.ingredient.stock_max,
                tags: this.ingredient.tags
            })
        }


    }

    openProviderOrderAdd(element) {
        this.navCtrl.push(ProviderOrderAddPage, {
            element: element,
            type: 'ingredient'
        });
    }


}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-name/ingredient-view-name.ts